import { useState } from "react";

import { isEligibleForExtensionPromotion } from "app/UtilitiesAndConstants/UtilityFunctions/extensionPromotion";

import { useExtensionPromotionEffect } from "./useExtensionPromotionEffect";

export const useShouldPromoteExtension = (): boolean => {
    const [shouldPromote, setShouldPromote] = useState(false);

    useExtensionPromotionEffect(
        () => isEligibleForExtensionPromotion(),
        () => setShouldPromote(true),
    );

    return shouldPromote;
};
